import request from '@/utils/request'
const BASE_URL = '/RpOutPocCostDts'

//委外费用单明细
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  getHistoryPocUnitPrice(data) {
    return request({
      url: BASE_URL + '/GetHistoryPocUnitPrice',
      method: 'post',
      data
    })
  },
  
}